/* src/app/pages/contactanos/contactanos.component.css */
.custom-input {
  height: 50px;
  border: none;
  border-bottom: 1px solid #5B6670 !important;
  border-radius: 6px !important;
  font-family: "Gotham Medium";
  font-size: 14px;
  font-weight: 400;
  color: #323E48;
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.custom-input::placeholder {
  color: #5B6670 !important;
  font-size: 14px;
  font-weight: 400;
  font-family: "Gotham Bold";
}
select.custom-input {
  padding-left: 20px !important;
}
#message {
  height: 165px;
}
.format-btn {
  width: 30px;
  height: 30px;
  border-color: #EB0029;
  color: #EB0029;
}
.format-btn:hover {
  background-color: #EB0029;
  color: #FFF;
}
.custom-input:focus {
  box-shadow: none;
  outline: none;
}
.custom-radio {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #ccc;
  background-color: white;
  position: relative;
  cursor: pointer;
  margin-right: 8px;
  vertical-align: middle;
  transition: all 0.2s ease;
}
.custom-radio:checked {
  background-color: #EB0029;
  border: 3px solid white;
  box-shadow: 0 0 0 2px #EB0029;
}
.btn-enviar {
  font-family: "Gotham Medium";
  font-weight: 500;
  font-size: 15px;
  color: #fff;
  background-color: #EB0029;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  transition: background-color 0.2s ease, box-shadow 0.1s ease;
  width: 126px;
  height: 45px;
  gap: 20px;
}
.btn-enviar:hover {
  background-color: #E50028;
}
.btn-enviar:active {
  background-color: #E30028;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.3);
}
.btn-enviar:disabled {
  background-color: #CFD2D3 !important;
  border-color: #CFD2D3 !important;
  color: #A2A9AD !important;
  pointer-events: none;
}
.btn-cancelar {
  font-family: "Gotham Medium";
  font-weight: 500;
  font-size: 15px;
  color: #323E48;
  background-color: white;
  border: 1px solid #323E48;
  padding: 10px 24px;
  border-radius: 4px;
  transition: all 0.2s ease;
  width: 126px;
  height: 45px;
  gap: 20px;
}
.btn-cancelar:hover,
.btn-cancelar:active,
.btn-cancelar:focus {
  color: #EB0029;
  border-color: #EB0029;
  background-color: white !important;
  box-shadow: none !important;
}
.formulario-container {
  background-color: #EBF0F2;
  padding: 50px 0px;
  border-radius: 8px;
  max-width: 1330px;
  margin: 0 auto;
  margin-bottom: 40px;
}
.custom-input,
.form-select,
textarea {
  background-color: #fff !important;
  border-radius: 6px 6px 0px 0px !important;
  border: 1px solid #ccc;
  height: 50px;
  padding: 18px 14px;
  font-size: 15px;
}
textarea {
  height: 89px !important;
  resize: none;
}
.custom-input:focus,
.form-select:focus,
textarea:focus {
  outline: none;
  box-shadow: none;
}
.from-title {
  font-family: "Gotham Bold";
  font-size: 25px;
  margin-bottom: 15px;
  color: #323E48;
}
.texto-from {
  font-family: "Gotham Book";
  font-size: 18px;
  text-align: center;
  margin-bottom: 40px;
  max-width: 460px;
  margin-left: auto;
  margin-right: auto;
  color: #5B6670;
}
.text-campo {
  font-family: "Gotham Book";
  font-size: 13px;
  color: #5B6670;
}
.text-camp-title {
  font-family: "Gotham Medium";
  font-size: 15px;
  color: #5B6670;
}
.text-from {
  font-family: "Gotham Medium";
  font-size: 15px;
  color: #323E48;
}
.floating-group input:focus,
.floating-group input:active,
.floating-group input:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  color: #323E48;
  border-bottom: 1px solid #5B6670;
}
.floating-group {
  position: relative;
  min-width: 360px;
  max-width: 360px;
  height: 71px;
  margin-bottom: 20px;
}
.floating-group input {
  width: 100%;
  height: 50px;
  padding: 29.5px 20px 2.5px 20px;
  font-size: 15px;
  line-height: 18px;
  border: none;
  border-bottom: 1px solid #5B6670;
  border-radius: 6px 6px 0 0;
  background-color: #FFFFFF;
  font-family: "Gotham Medium";
  color: #323E48;
}
.floating-label {
  position: absolute;
  top: 14px;
  left: 20px;
  font-size: 15px;
  color: #323E48;
  pointer-events: none;
  transition: all 0.2s ease-out;
  font-family: "Gotham Medium";
}
.floating-group input:focus + .floating-label,
.floating-group input:not(:placeholder-shown) + .floating-label,
.floating-group textarea:focus + .floating-label,
.floating-group textarea:not(:placeholder-shown) + .floating-label {
  top: 2px;
  font-size: 13px;
  font-family: "Gotham Book";
  color: #5B6670;
}
.floating-textarea {
  position: relative;
  width: 100%;
  height: 70px;
  font-family: "Gotham Medium";
  color: #323E48;
}
.floating-label-textarea {
  position: absolute;
  top: 5px;
  left: 20px;
  color: #323E48;
  font-size: 15px;
  pointer-events: none;
  transition: all 0.2s ease;
  font-family: "Gotham Medium";
}
.floating-textarea textarea:focus {
  outline: none !important;
  box-shadow: none !important;
}
.floating-textarea textarea:focus + .floating-label-textarea,
.floating-textarea textarea:not(:placeholder-shown) + .floating-label-textarea {
  top: 5px;
  font-size: 13px;
  color: #5B6670;
  font-family: "Gotham Book";
}
.floating-textarea textarea {
  border: none;
  border-bottom: 1px solid #5B6670;
}
.form-control {
  padding: 25px 20px 5px 20px;
}
.custom-wrapper {
  padding: 25px 20px 5px 20px;
}
.custom-select-wrapper {
  max-width: 360px;
  min-width: 360px;
  height: 71px;
  position: relative;
  font-family: "Gotham Medium";
  margin-bottom: 20px;
}
.custom-select-display {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #5B6670;
  border-radius: 6px 6px 0 0;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  cursor: pointer;
  position: relative;
}
.custom-select-text {
  height: 43px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.custom-select-label {
  font-size: 15px;
  line-height: 18px;
  color: #323E48;
  font-family: "Gotham Medium";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.2s ease;
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-select-label.float {
  font-size: 13px;
  font-family: "Gotham Book";
  color: #5B6670;
  top: 0;
  transform: translateY(0);
}
.selected-value {
  font-size: 15px;
  line-height: 20px;
  color: #323E48;
  font-family: "Gotham Medium";
  margin-top: 26.5px;
}
.custom-select-options {
  position: absolute;
  top: 52px;
  left: 0;
  width: 100%;
  border-radius: 5px 5px 6px 6px;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  z-index: 3;
  margin-top: 6px;
  padding: 0;
  list-style: none;
  overflow-y: hidden;
}
.custom-select-options li {
  padding: 15px 20px;
  font-size: 15px;
  color: #5B6670;
  cursor: pointer;
  font-family: "Gotham Book";
  height: 50px;
  display: flex;
  align-items: center;
}
.custom-select-options li:hover {
  background-color: #F4F7F8;
  color: #323E48;
}
.arrow {
  transition: transform 0.3s ease;
  transform-origin: center;
  width: 15px;
  height: 7.16px;
}
.gx-2 {
  --bs-gutter-x: 1.5rem;
}
input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #FFFFFF inset !important;
  -webkit-text-fill-color: #323E48 !important;
  caret-color: #323E48 !important;
  font-family: "Gotham Medium" !important;
  transition: background-color 9999s ease-in-out 0s;
}
input:-webkit-autofill:focus,
textarea:-webkit-autofill:focus,
select:-webkit-autofill:focus {
  box-shadow: 0 0 0px 1000px #FFFFFF inset !important;
  -webkit-text-fill-color: #323E48 !important;
}
.custom-wrapper {
  border: none;
  border-bottom: 1px solid #ccc;
  padding: 8px 4px;
  width: 100%;
}
.floating-group.error .custom-wrapper {
  border-bottom: 1px solid #EB0029;
}
.floating-group.error label.floating-label,
.floating-group.error .floating-label,
.floating-group.error .floating-label.float {
  color: #EB0029 !important;
}
.floating-group.error .floating-label::after {
  color: #EB0029;
}
.helper-error,
.text-danger {
  color: #EB0029;
  font-size: 12px;
  line-height: 14px;
  margin-top: 7px;
  font-family: "Gotham Book";
}
.estados-scroll {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
.estados-scroll::-webkit-scrollbar {
  width: 6px;
}
.estados-scroll::-webkit-scrollbar-thumb {
  background-color: #aaa;
  border-radius: 3px;
}
.estados-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #888;
}
.estados-scroll {
  scrollbar-width: thin;
  scrollbar-color: #aaa transparent;
}
.col-12 {
  max-width: 774px;
}
@media (max-width: 743.5px) {
  .col-12 {
    max-width: 384px;
  }
}
.form-check {
  padding-left: 1em;
  padding-right: 15px;
}
.radios-contacto {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
@media (max-width: 454px) {
  .texto-from {
    padding: 0 16px;
  }
}
/*# sourceMappingURL=/banorte/__host/inmuebles/Inmuebles/contactanos.component.css.map */
